'use strict';

var FaresOptimizerPagerDirective = function FaresOptimizerPagerDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FaresOptimizerPagerController',
    template: require('../templates/fares-optimizer-pager.html'),
    scope: {
      screenState: '='
    }
  };
};
FaresOptimizerPagerDirective.$inject = [];
module.exports = FaresOptimizerPagerDirective;